import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { actions as axisOrdersActions } from '../../actions/axisOrders';
import MapStatusTable from './MapStatusTable';
import Constants from '../../constants/mapStatusTable';
import LuciPropTypes from '../../propTypes/';
import OverlayTable from './OverlayTable';
import AppSettings from '../../settings';
import { localizeAxis as localize } from '../../util/localizeUtils';

let mapStatusWorker = null;

class MapStatus extends Component {
  UNSAFE_componentWillMount() {
    if (this.props.loggedIntoAxis) {
      this.getMaps();
    }
  }

  UNSAFE_componentWillUpdate(nextProps) {
    if (!nextProps.loggedIntoAxis) {
      clearTimeout(mapStatusWorker);
    } else if (!this.props.loggedIntoAxis) {
      this.getMaps();
    }
  }

  componentWillUnmount() {
    clearTimeout(mapStatusWorker);
  }

  getMaps = () => {
    if (!this.props.mapStatusLoading && this.props.initialized) {
      this.props.getMapStatus();
    }
    mapStatusWorker = setTimeout(() => this.getMaps(), AppSettings.feedPollingRate);
  };

  render() {
    const header = [
      {
        title: localize('titleHeader'),
        width: Constants.TITLE_COLUMN_WIDTH
      },
      {
        title: localize('statusHeader'),
        width: Constants.STATUS_COLUMN_WIDTH
      }
    ];

    return (
      <OverlayTable
        title={localize('mapStatusHeader')}
        visible={this.props.visible}
        header={header}
        close={this.props.close}
        left={this.props.left}
      >
        <MapStatusTable maps={this.props.maps} />
      </OverlayTable>
    );
  }
}

MapStatus.defaultProps = {
  visible: false,
  close: () => {}
};

MapStatus.propTypes = {
  maps: PropTypes.arrayOf(LuciPropTypes.AxisMap).isRequired,
  getMapStatus: PropTypes.func.isRequired,
  visible: PropTypes.bool,
  close: PropTypes.func,
  mapStatusLoading: PropTypes.bool.isRequired,
  loggedIntoAxis: PropTypes.bool.isRequired,
  left: PropTypes.string.isRequired,
  initialized: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
  maps: state.axisOrders.maps,
  mapStatusLoading: state.axisOrders.mapStatusLoading,
  loggedIntoAxis: state.auth.axisUserProfile.services.length > 0,
  initialized: state.app.initialized
});

const mapActionCreators = {
  getMapStatus: axisOrdersActions.getMapStatus
};

export default connect(
  mapStateToProps,
  mapActionCreators
)(MapStatus);



// WEBPACK FOOTER //
// ./app/components/DeliveryStatus/MapStatus.js